import React from 'react'
import { Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import CameraAltIcon from '@mui/icons-material/CameraAlt'

import scanButtonIcon from '../../assets/unlockPinIcons/scan_qr_code_icon.png'
import { isScreenSizeSmall } from '../common/utils'

type QRCodeScanCardProps = {
  disable: boolean
  handleScanFromVideoDevice: () => void
}

const QRCodeScanCard = ({
  disable,
  handleScanFromVideoDevice,
}: QRCodeScanCardProps): JSX.Element => {
  const { t } = useTranslation()

  const getButtonContentForMobileView = (): string => {
    return t('unlock_pin_page.capture_and_getpin_mobile')
  }

  const getButtonContentDesktopView = (): JSX.Element => {
    return (
      <>
        <CameraAltIcon /> {t('unlock_pin_page.capture_and_getpin_desktop')}
      </>
    )
  }

  return (
    <Card
      onClick={
        !disable && isScreenSizeSmall() ? handleScanFromVideoDevice : undefined
      }
      style={{
        borderRadius: isScreenSizeSmall() ? '30px' : '20px',
        borderColor: '#C3C3C3',
        borderWidth: '1px',
      }}
    >
      <Card.Body>
        <div className="qr-card-container">
          <div className="qr-scan-card">
            <div className="qr-card-header">
              <img
                alt="QR Scan Icon"
                className="qr-scan-icon"
                src={scanButtonIcon}
              />
            </div>
            <div className="qr-card-footer">
              <button
                className="qr-scan-button"
                disabled={disable}
                type="button"
                onClick={
                  !isScreenSizeSmall() ? handleScanFromVideoDevice : undefined
                }
              >
                {isScreenSizeSmall()
                  ? getButtonContentForMobileView()
                  : getButtonContentDesktopView()}
              </button>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  )
}

export default QRCodeScanCard
